import React, { Component } from 'react'
import request from '../../../lib/requester'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import moment from 'moment'
import _ from 'lodash'
import ReactExport from "react-export-excel-hot-fix"
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import DatePicker from "react-datepicker";

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class ClaimSummaryCHD extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataTable: [],
      baseTable: [],
      loading: false,
      user: JSON.parse(window.localStorage.getItem('is_user')) || {},
      success: '',
      filter_program_no: '',
      filter_program_type: '',
      filter_submit_from: new Date(),
      filter_submit_to: new Date(),
      error: [],
      lovProgram: [],
      lovProgramType: []
    }
  }

  componentDidMount = () => {
    this.getDataProgramType()
  }

  getDataProgramType = () => {
    let url = '/api/traces_chd/v1/program/data-program?org_id=9'
    request.getCHD(url, {
      success: function (response) {
        let { ProgramType } = response.data.data
        this.setState({
          lovProgramType: ProgramType
        })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  getDataSummary = () => {
    let url = '/api/traces_chd/v1/claim/data-summary-all'
    let param = {
      branch: this.state.user.branch
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        let { data } = response.data
        this.setState({ dataTable: data, baseTable: data, loading: false })
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  renderTable = () => {
    let app = this
    const data = {
      columns: [
        {
          Header: 'CLAIM NO',
          accessor: 'claim_number',
          filterable: true,
          width: 200
        },
        {
          Header: 'SKP NO',
          accessor: 'skp_number',
          filterable: true,
          width: 200
        },
        {
          Header: 'REFF NO / IM',
          accessor: 'ref_number',
          filterable: true,
          width: 200
        },
        {
          Header: 'PROGRAM TYPE',
          accessor: 'program_type',
          filterable: true,
          width: 150
        },
        {
          Header: 'DESCRIPTION',
          accessor: 'description',
          filterable: true,
          width: 200
        },
        {
          Header: 'CLAIM EXP DATE',
          accessor: 'claim_exp_date',
          Cell: row => (
            <span>
              <span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss") : ""}
              </span>
            </span>
          ),
          width: 200
        },
        {
          Header: 'SUBMITTED DATE',
          accessor: 'creation_date',
          Cell: row => (
            <span>
              <span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss") : ""}
              </span>
            </span>
          ),
          width: 200
        },
        {
          Header: 'AMOUNT',
          accessor: 'total',
          Cell: row => (
            <span>{ app.thousandSeparator(row.value)}</span>
          ),
          width: 200
        },
        {
          Header: 'CUSTOMER',
          accessor: 'customer_name',
          filterable: true,
          width: 200
        },
        {
          Header: 'ACCOUNT OWNER',
          accessor: 'bank_acc_owner',
          filterable: true,
          width: 200
        },
        {
          Header: 'STATUS',
          accessor: 'status',
          filterable: true,
          Cell: function(row) {
            let badgeClass = app.badgeType(row.value, 'type')
            return (<div className={badgeClass}>{row.value ? row.value.toUpperCase() : ''}</div>)
          }
        },
        {
          Header: 'DOWNLOAD KWITANSI',
          accessor: 'claim_id',
          Cell: (row) => {
            if (row.original.status === 'Approved') {
              return (
                <span>
                  <button className="btn btn-success btn-sm" onClick={() => { app.goDownload(row) }}><i className="fas fa-download"></i> Download</button>
                </span>
              )
            } else {
              return (<span>&nbsp;</span>)
            }
          }
        },
        {
          Header: 'UPLOAD KWITANSI',
          accessor: 'claim_id',
          Cell: (row) => {
            if (row.original.status === 'Approved') {
              return (
                <span>
                  <button className="btn btn-warning btn-sm" onClick={() => { app.goUpload(row) }}><i className="fas fa-upload"></i> Upload</button>
                </span>
              )
            } else {
              return (<span>&nbsp;</span>)
            }
          }
        },
        {
          Header: '',
          accessor: 'claim_id',
          Cell: (row) => {
            return (
              <span>
                <button className="btn btn-info btn-sm" onClick={() => { app.goDetail(row) }}><i className="fas fa-eye"></i> View</button>
              </span>
            )
          }
        }
      ],
      rows: this.state.dataTable
    }
    return (<ReactTable
      className="fullWidth"
      data={data.rows}
      columns={data.columns}
      defaultPageSize={10}
      defaultFilterMethod={((filter, row, column) => {
        let columnes = ""
        switch (filter.id) {
          case "start_date":
            columnes = row._original.formatted_start_date
            break;
          case "end_date":
            columnes = row._original.formatted_end_date
            break;
          case "claim_exp_date":
            columnes = row._original.formatted_exp_date
            break;
          case "creation_date":
            columnes = row._original.formatted_submitted_date
            break;
          default:
            columnes = row[filter.id]
        }

        return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
      })}
    />)
  }

  goDetail = (row) => {
    this.props.history.push('/admin/claim-chd/summary/' + row.value)
  }

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable
    let filename = 'claim-summary-' + moment(new Date()).format('DDMMYYYYHHmmss')

    return (
      <ExcelFile filename={filename} fileExtension="xls" element={(<button className="btn btn-success"><i className="fas fa-file-excel" />Export to excel</button>)}>
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="Claim Number" value="claim_number" />
          <ExcelColumn label="Traces Number" value="skp_number" />                    <ExcelColumn label="Skp Number" value="skp_number" />
          <ExcelColumn label="Ref No" value="ref_number" />
          <ExcelColumn label="Program Type" value="program_name" />
          <ExcelColumn label="Description" value="description" />
          <ExcelColumn label="Start Date" value="formatted_start_date" />
          <ExcelColumn label="End Date" value="formatted_end_date" />
          <ExcelColumn label="Claim Exp" value="formatted_claim_exp" />
          <ExcelColumn label="Submitted Date" value="creation_date" />
          <ExcelColumn label="Amount" value="total_claim" />
          <ExcelColumn label="Customer" value="customer_name" />
          <ExcelColumn label="Status" value="status" />
        </ExcelSheet>
      </ExcelFile>
    );
  }

  badgeType = (status, format) => {
    let output = {
      type: ''
    }
    switch(status) {
      case 'Draft':
        output.type = 'badge badge-info'
        break
      case 'Approved':
        output.type = 'badge badge-success'
        break
      case 'Rejected':
        output.type = 'badge badge-danger'
        break
    }
    return output[format]
  }

  thousandSeparator = (value) => {
    if (value.length === 0) return

    value = value.toString().replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  goUpload = (row) => {
    this.props.history.push('/admin/claim-chd/upload-kwitansi/' + row.row.claim_id)
  }

  goDownload = (row) => {
    let url = '/api/traces_chd/v1/assignment/doc-kwitansi?id=' + row.value + '&email=' + this.state.user.username
    this.setState({ loading: true, error: [] })
    request.getCHD(url, {
      success: function(response) {
        let { fullpath } = response.data.data
        if (fullpath) {
          window.open(fullpath, '_blank')
        }
        this.setState({ loading: false })
        
        if(row.original.program_type != 'BRANDING RELASI'){
          this.handleDetailInsentif(row)
        }
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
        let msg = e.response.data && e.response.data.message ? e.response.data.message : 'Failed to download, please try again'
        window.scrollTo(0,0)
        this.setState({ error: [msg] })
      }.bind(this)
    })
  }

  handleDetailInsentif = (row) => {
    let url = '/api/traces_chd/v1/claim/detail-insentif'
    let param = {
      customer_name: row.original.customer_name,
      customer_id: row.original.customer_id,
      program_name: row.original.program_type,
      package: row.original.package,
      branch: row.original.branch_code,
      program_start: row.original.start_date,
      program_end: row.original.end_date,
      skp_number: row.original.skp_number
    }
    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        this.setState({ loading: false })
        if (data.fullpath) {
          window.open(data.fullpath, '_blank')
        }
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i className="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  handleChangeInput = (e) => {
    let value = e.target.value
    let name = e.target.name
    this.setState({[name]: value})
  }

  handleDateSubmitTo = (date) => {
    this.setState({ filter_submit_to: date })
  }

  handleDateSubmitFrom = (date) => {
    this.setState({ filter_submit_from: date })
  }

  getData = (isExcel) => {
    let url = '/api/traces_chd/v1/claim/data-summary-all'
    let param = {
      branch: this.state.user.branch,
      program_id: this.state.filter_program_type,
      excel: isExcel ? true : false,
      program_number:this.state.filter_program_no,
      start_date: this.state.filter_submit_from,
      end_date: this.state.filter_submit_to
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        let { data } = response.data
        this.setState({ dataTable: data.data, baseTable: data.data, loading: false })
        if (isExcel) {
          let url = data.fullpath
          window.open(url, '_blank')
        }
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  handleSearch = () => {
    this.getData(false)
  }

  handleExport = () => {
    this.getData(true)
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    { this.showNotification() }
                    <div className="row">
                      <div className="col-lg-6 float-left">
                        <div className="row">
                          <div className="col-lg-12">
                            {/* {this.exportToExcel()} */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 float-right">
                      </div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-3">
                                <label>Program Type:</label>
                                <select className="form-control" name="filter_program_type" value={this.state.filter_program_type} onChange={this.handleChangeInput.bind(this)}>
                                  <option value="">- Select Program Type -</option>
                                  {
                                    this.state.lovProgramType.map((item, index) => (
                                      <option value={item.prog_type_id} key={index}>{item.program_name}</option>
                                    ))
                                  }
                                </select>
                              </div>
                              <div className="col-md-3">
                                <label>Program No:</label>
                                <input type="text" className="form-control" value={this.state.filter_program_no} name="filter_program_no" onChange={this.handleChangeInput.bind(this)} placeholder="Program No" />
                              </div>
                              <div className="col-md-3">
                                <label>Claim Submit Date From:</label>
                                <DatePicker
                                  selected={this.state.filter_submit_from}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="top-end"
                                  onChange={this.handleDateSubmitFrom}
                                />
                              </div>
                              <div className="col-md-3">
                                <label>Claim Submit Date To:</label>
                                <DatePicker
                                  selected={this.state.filter_submit_to}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="top-end"
                                  onChange={this.handleDateSubmitTo}
                                />
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-md-3">
                                <button className="btn btn-primary btn-block" onClick={this.handleSearch.bind(this)} ><i className="fa fa-search" /> Search</button>
                              </div>
                              <div className="col-md-3">
                                <button className="btn btn-success btn-block" onClick={this.handleExport.bind(this)}><i className="fa fa-file-excel" /> Export Excel</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        {this.renderTable()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default ClaimSummaryCHD